<div class="picker-container">
  <div class="picker-header">
    <h2 mat-dialog-title>Escolher template</h2>
    <button
      mat-icon-button
      (click)="cancelar()"
      matTooltip="Fechar"
      aria-label="Fechar galeria de templates"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="picker-nota">Criados pela equipe de criação. O conteúdo não é editado aqui.</p>

  @if (!templates.length) {
    <p class="picker-vazio">
      <mat-icon>inbox</mat-icon>
      Nenhum template disponível.
    </p>
  }

  <div class="picker-lista">
    @for (template of templates; track $index) {
      <div class="template-card" [class.selecionado]="template.id === selecionadoId">
        <div class="template-cabecalho">
          <div class="template-textos">
            <strong>{{ template.nome }}</strong>
            <span class="template-assunto">{{ template.assunto_padrao }}</span>
          </div>

          <div class="template-acoes">
            @if (template.html) {
              <button mat-button (click)="alternarPreview(template)">
                <mat-icon>{{
                  expandidoId === template.id ? 'visibility_off' : 'visibility'
                }}</mat-icon>
                {{ expandidoId === template.id ? 'Ocultar' : 'Pré-visualizar' }}
              </button>
            }
            <button mat-stroked-button color="primary" (click)="escolher(template)">
              {{ template.id === selecionadoId ? 'Selecionado' : 'Usar este' }}
            </button>
          </div>
        </div>

        @if (expandidoId === template.id && htmlSeguro(template)) {
          <iframe
            class="template-preview"
            sandbox
            title="Pré-visualização de {{ template.nome }}"
            [srcdoc]="htmlSeguro(template)"
          ></iframe>
        }
      </div>
    }
  </div>
</div>
